module.exports = __webpack_public_path__ + "static/forma1-7af9ee5c7b561135c9e917744ea325e3.png";